import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component } from "@eastsideco/salvo-ts";
import { type ProductGroup } from "@apptus/esales-api";
import { ProductCard } from "../ProductCard/ProductCard";
import { ProductForm } from "../Product/ProductForm";
import { ProductOptionPicker } from "../Product/ProductOptionPicker";
import { ProductDropdownOption } from "../Product/ProductDropdownOption";

@Component
export class VoyadoProductCard extends ThemeComponent {
    private _productGroup?: ProductGroup;

    public section = 'voyado-product-card';

    set productGroup(productGroup: ProductGroup | undefined) {
        this._productGroup = productGroup;
        void this.renderContents();
    }

    get productGroup() {
        return this._productGroup;
    }

    async renderContents() {
        if (! this.productGroup) {
            return;
        }

        const [product] = this.productGroup.products;

        const separator = product.link.includes('?') ? '&' : '?';
        const response = await fetch(`${product.link}${separator}sections=${this.section}`);
        const responseJson = await response.json();

        const quickAddSection = responseJson[this.section];

        const el = document.createElement('div');
        el.innerHTML = quickAddSection;

        const productCardElement = el.querySelector('product-card') as ProductCard | null;

        if (!productCardElement) {
            return;
        }

        const productFormElement = productCardElement.querySelector('product-form') as ProductForm | null;

        productCardElement.voyadoTicket = product.ticket;

        if (productFormElement) {
            productFormElement.voyadoTicket = product.ticket;
        }


        this.replaceChildren(productCardElement);
    }
}
